const initialEmployee = {
    customers: [],
    allemailids : [],
    allgstnumbers : [],
    customermessages : {}
};

const customerReducer = (customer = initialEmployee, action) => {
    switch (action.type) {
        case "UPDATE_CUSTOMER":
            return {
                ...customer, customermessages: action.payload.data
            };
        case "ADD_CUSTOMER":
            return {
                ...customer, customermessages: action.payload.data
            };
        case 'GET_CUSTOMER':
            return {
                ...customer, customers: action.payload.data
            };
        case 'ALL_CUSTOMER_EMAILID':
            return {
                ...customer, allemailids: action.payload.data
            };
        case 'ALL_CUSTOMER_GSTNUMBER':
            return {
                ...customer, allgstnumbers: action.payload.data
            };
        case "CUSTOMER_STATUS":
            return {
                ...customer, customermessages: action.payload.data
            };  
            
        default:
            return customer;
    }
}
export default customerReducer;